"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgTestEnvironment(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { d: "M14.571 4a1 1 0 011 1v.286a1 1 0 01-1 1l-.143-.001v3.43l4.785 7.176a2 2 0 01-1.495 3.102l-.17.007H6.738a2 2 0 01-1.664-3.11l4.784-7.176V6.285h-.143a1 1 0 01-1-1V5a1 1 0 011-1h4.857zm-1.144 2.285h-2.571l.001 3.732-2.881 4.321 8.336.005-2.883-4.326-.002-3.732z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('TestEnvironment')(SvgTestEnvironment);
//# sourceMappingURL=TestEnvironment.js.map